import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

const THEMES = {
  light: { label: "Claro", icon: "sun" },
  dark: { label: "Oscuro", icon: "moon" },
  calm: { label: "Calma", icon: "heart" },
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("ea_theme") || "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("ea_theme", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
